export default "__VITE_ASSET__c6474fc7__"